//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

/**
 * TODO: PD-330267 — DELETE THIS FILE once `moderation:view` is published in
 * `session.permissions` by LWS.
 *
 * The task does not exist in any environment yet, so without this there is no
 * way to exercise the mode switch or the moderator navigation flow. Guarded on
 * NODE_ENV, not on `session.isProduction`: this is a build-time check, so the
 * branch is compiled out of production bundles rather than merely disabled at
 * runtime. Local dev runs against prod data with `isProduction === true`, which
 * is why the runtime guard was the wrong tool.
 *
 * Enable:  localStorage.setItem('moderationMode:forceCapable', 'true')
 * Disable: localStorage.removeItem('moderationMode:forceCapable')
 */
const CAPABILITY_OVERRIDE_KEY = 'moderationMode:forceCapable';

export const getHasCapabilityOverride = (): boolean => {
  if (process.env.NODE_ENV === 'production') {
    return false;
  }

  try {
    return window.localStorage.getItem(CAPABILITY_OVERRIDE_KEY) === 'true';
  } catch {
    // Safari private browsing throws on localStorage access.
    return false;
  }
};
